"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("containers/TableMaker/constants");
var ordered_1 = require("utils/selectors/ordered");
var DisableVendor_1 = __importDefault(require("./CellComponents/DisableVendor"));
var LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, XS = constants_1.CellSize.XS;
var tableConf = {
    headersMap: {
        name: 'Vendor',
        accountingProvider: 'Accounting',
        importMethods: '',
    },
    config: {
        noFooter: true,
        selector: ordered_1.selectAllRechargedVendors,
        defaultSort: { key: 'name', order: 1 },
    },
    extractors: {
        importMethods: function (vendor) { return vendor.importMethods.filter(function (method) { return method !== vendor.mainImportMethod; }).join() || undefined; },
    },
    cells: [
        { field: 'name', cell: { width: LG }, avatar: { size: 'xxs' }, truncate: {} },
        { field: 'accountingProvider', cell: { width: MD }, truncate: {} },
        { fields: ['mainImportMethod', 'importMethods'], cell: { width: LG }, truncate: {} },
        { key: 'enabled', cell: { width: XS, isActionCell: true }, renderComponent: DisableVendor_1.default },
    ],
};
exports.default = tableConf;
